var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "email-login-form"
  }, [_c('div', {}, [_c('div', {
    staticClass: "left-login"
  }, [_vm._m(0), _c('div', {}, [_c('router-link', {
    attrs: {
      "to": "/smart-login"
    }
  }, [_c('button', {
    staticClass: "qr-login-btn"
  }, [_c('img', {
    staticClass: "me-2",
    attrs: {
      "src": require("../../assets/images/qr-icon.svg"),
      "alt": "qr icon"
    }
  }), _vm._v("Login with QR ")])])], 1)])]), _c('h4', {
    staticClass: "login-title mb-0"
  }, [_vm._v("Login to Continue")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.checkEmailLogin);
            }
          }
        }, [_c('custom-input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "customMessages": "Please enter your email address.",
            "customEmailMessage": "Please enter a valid email address",
            "labelFor": "Email",
            "labelName": "Email",
            "inputName": "Email",
            "formGroupClass": "form-group mb-1",
            "placeholder": "Please enter your email",
            "isErrorFlagSet": _vm.emailErrorFlag,
            "vmodel": _vm.form.username
          },
          on: {
            "emitChanges": _vm.resetErrorMsg,
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "username", $event);
            }
          }
        }), _vm.emailErrorFlag && _vm.lockoutTime === 0 ? _c('div', {
          staticClass: "valid-error"
        }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e(), _c('router-link', {
          staticClass: "text-end login-highlight",
          attrs: {
            "to": {
              name: 'ForgotEmail'
            }
          }
        }, [_c('p', {
          staticClass: "float-right"
        }, [_vm._v("Forgot Email?")])]), _c('button', {
          staticClass: "submit-btn  next-btn",
          attrs: {
            "disabled": _vm.loginLoader || _vm.lockoutTime > 0,
            "type": "submit"
          }
        }, [_vm.loginLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Next ")], 1)], 1)];
      }
    }])
  }), _vm.lockoutTime > 0 ? _c('lockout-timer', {
    attrs: {
      "lockout-seconds": _vm.lockoutTime
    },
    on: {
      "lockout-expired": _vm.handleLockoutExpired
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "image-fluid"
    }
  })]);
}]

export { render, staticRenderFns }